import {
  onboardingV1Routes,
  onboardingV2Routes,
  isOnboardingRoute,
  secureDocUploaderRoutes,
  isSecureDocUploaderRoute,
} from './routes/onboardingRoutes'

import {
  clientRoutes,
  prospectRoutes,
  isOnlineExperienceClientRoute,
  isOnlineExperienceProspectRoute,
} from './routes/onlineExperienceRoutes'

export {
  onboardingV1Routes,
  onboardingV2Routes,
  isOnboardingRoute,
  secureDocUploaderRoutes,
  clientRoutes,
  prospectRoutes,
  isSecureDocUploaderRoute,
  isOnlineExperienceClientRoute,
  isOnlineExperienceProspectRoute,
}



// WEBPACK FOOTER //
// ./src/routing/routes.js